// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-2nFmT","btnDetail":"index-btnDetail-3YqUL"};